import config from 'config'
import { Redirect } from 'react-router-dom'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/adventurous-journeys`,
    exact: true,
    component: () => (
      <Redirect to={`${publicPath}/adventurous-journeys/my-events`} />
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/my-events`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEvents
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }>
          <Page.AjEventsMy {...props} params={get(props, 'match.params', {})} />
        </Page.AjEvents>
      </Main>
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/all-events`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEvents
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }>
          <Page.AjEventsAll {...props} params={get(props, 'match.params', {})} />
        </Page.AjEvents>
      </Main>
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/templates`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEvents
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }>
          <Page.AjEventTemplates {...props} />
        </Page.AjEvents>
      </Main>
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/templates/new`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEventTemplateNew {...props} />
      </Main>
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/templates/:id`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEventTemplateDetail {...props} params={get(props, 'match.params', {})} />
      </Main>
    )
  },

  {
    path: `${publicPath}/adventurous-journeys/new`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEventNew {...props} params={get(props, 'match.params', {})} />
      </Main>
    )
  },

  {
    path: `${publicPath}/adventurous-journeys/:id`,
    exact: true,
    component: props => (
      <Redirect to={`${publicPath}/adventurous-journeys/${props.match.params.id}/detail`} />
    )
  },
  {
    path: `${publicPath}/adventurous-journeys/:id`,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.AjEvent {...props}
          params={get(props, 'match.params', {})}
          tabs={
          <Tabs {...props} params={get(props, 'match.params', {})} />
        }/>
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/adventurous-journeys/:id/detail`,
        exact: true,
        component: props => (
          <Page.AjEventDetail {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/adventurous-journeys/:id/event-participants`,
        exact: true,
        component: props => (
          <Page.AjEventParticipants {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/adventurous-journeys/:id/files`,
        exact: true,
        component: props => (
          <Page.AjEventFiles {...props} params={get(props, 'match.params', {})} />
        )
      }
    ]
  }
]

export default routes
